/**
 * GC 除外コマ (gc-excluded-koma-visibility design) の表示用ロジック。
 *
 * backend が返す `excludedKomaNumbers` (1-origin, 1..48, 昇順) から
 * 「送信コマ範囲」(= 除外集合の補集合) を導出する (frontend が導出する invariant
 * 「送信コマ集合 = 全 48 − 除外集合」)。
 */
import { KOMA_COUNT } from '~/constants/koma'

/**
 * 除外コマ集合の補集合 (= 送信コマ集合) を 1..48 の昇順で返す
 * (invariant「送信コマ集合 = 全 48 − 除外集合」)。
 */
export function submittedKomaNumbers(excludedKomaNumbers: number[]): number[] {
  const excluded = new Set(excludedKomaNumbers)
  const out: number[] = []
  for (let koma = 1; koma <= KOMA_COUNT; koma++) {
    if (!excluded.has(koma)) {
      out.push(koma)
    }
  }
  return out
}
